/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteEnterpriseModal = ({ modalData, isOpen, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Delete {modalData}?</ModalHeader>
      <ModalBody>Do you really want to delete the {modalData}?</ModalBody>
      <ModalFooter>
        {modalData === 'Company Group' ? (
          <Button color="primary" onClick={() => onConfirm('no')}>
            Clear Group
          </Button>
        ) : null}
        <Button color="primary" onClick={() => onConfirm('yes')}>
          Delete
        </Button>
        <Button color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteEnterpriseModal;
